import { frontendURL } from 'dashboard/helper/URLHelper';

export const routes = [
  {
    path: frontendURL('accounts/:accountId/flows'),
    name: 'wasapi_flows_index',
    component: () => import('./pages/FlowsIndex.vue'),
    meta: { permissions: ['administrator'] },
  },
  {
    path: frontendURL('accounts/:accountId/flows/runs'),
    name: 'wasapi_flow_runs',
    component: () => import('./pages/FlowRunsPage.vue'),
    meta: { permissions: ['administrator'] },
  },
  {
    path: frontendURL('accounts/:accountId/flows/:flowId/edit'),
    name: 'wasapi_flow_edit',
    component: () => import('./pages/FlowEditor.vue'),
    meta: { permissions: ['administrator'] },
  },
];
